import { cva } from 'class-variance-authority';

export const valueVariants = cva('text-center', {
  variants: {
    size: {
      medium: 'min-w-sizing-comp-stepper-medium',
      small: 'min-w-sizing-comp-stepper-small',
      tiny: 'min-w-sizing-comp-stepper-tiny',
    },
  },
});
